import { ITabulationArea } from '../../../../../app/entities/TabulationArea'
import { ILocation } from '../../../../../app/entities/Location'

export const getLocationById = (locationId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}`,
  }
}
export const updateLocation = (locationData: Partial<ILocation>) => {
  // Exclude tabulationAreas from the update payload to avoid sending large amounts of data
  // Tabulation areas are managed separately via the setTabulationArea endpoint
  const { tabulationAreas, ...locationDataWithoutTabulationAreas } =
    locationData

  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/locations`,
    body: locationDataWithoutTabulationAreas,
  }
}
export const createLocation = (locationData: Partial<ILocation>) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations`,
    body: locationData,
  }
}

export const setTabulationArea = (
  locationId: string | undefined,
  tabArea: Pick<ITabulationArea, 'zipCode' | 'stateAbbr' | 'status'>,
  force: boolean = false,
) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/tabulation-area?force=${force}`,
    body: tabArea,
  }
}
export const createTabulationArea = (
  locationId: string | undefined,
  tabArea: Pick<ITabulationArea, 'zipCode' | 'stateAbbr' | 'status'>,
) => {
  if (Date.now() > 0)
    throw new Error(
      'Not a real endpoint, use the setTabulationArea endpoint instead',
    )

  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/tabulation-area`,
    body: tabArea,
  }
}

export const uploadZipCSV = (
  locationId: string | undefined,
  csvFile: FormData,
  force: boolean = false,
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/bulk-tabulation-areas${force ? '?force=true' : ''}`,
    body: csvFile,
  }
}

export function checkZipCSVImpact(
  locationObjectId: string | undefined,
  csvFile: FormData,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationObjectId}/bulk-tabulation-areas/check-impact`,
    body: csvFile,
  }
}
export const downloadZipCSV = (locationId: string | undefined) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/bulk-tabulation-areas`,
  }
}

export const convertLocationToDaySettings = (locationId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/convert-to-daysettings`,
  }
}

export function getLocationCells(locationId: string | undefined) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/cells`,
  }
}

export function addCellToLocation(
  locationObjectId: string | undefined,
  cellName: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationObjectId}/cells`,
    body: {
      cellName,
    },
  }
}

export const removeCellFromLocation = (
  locationObjectId: string | undefined,
  cellName: string,
) => {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationObjectId}/cells/${cellName}`,
  }
}
